<app-page-header></app-page-header>

<div class="source-page">
  <div class="source-page-header">
    <div class="source-header-left">
      <button class="section-back-btn" (click)="router.navigate(['/indexing'])" title="Back to Indexing" aria-label="Back to Indexing">
        <svg class="back-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M19 12H5"></path>
          <path d="M12 19l-7-7 7-7"></path>
        </svg>
      </button>
      <h2 class="source-title" [title]="selectedLoanContext?.row?.fileName || selectedLoanContext?.loanNumber || ''">{{ selectedLoanContext?.row?.fileName || selectedLoanContext?.loanNumber }}</h2>
      @if (sourceFiles.length > 0) {
        <span class="source-subtitle"
              [title]="totalDocuments + ' documents | ' + totalPageCount + ' pages | ' + miscellaneousCount + ' misc'">
          {{ totalDocuments }} documents | {{ totalPageCount }} pages | {{ miscellaneousCount }} misc
        </span>
      }
    </div>

    <div class="header-controls-group">
      <div class="source-review-controls">
        <div class="source-review-select-wrapper">
          <select class="source-review-select" title="Review status" [(ngModel)]="sourceReviewStatus">
            <option value="under-review">Under Review</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
          </select>
          <span class="material-icons source-review-dropdown-indicator" aria-hidden="true">arrow_drop_down</span>
        </div>
        <button
          type="button"
          class="source-save-btn"
          title="Save changes"
          [disabled]="!canSaveAnnotationChanges()"
          (click)="onSaveChanges()">Save Changes</button>
      </div>
    </div>
  </div>

  <div
    #contentGrid
    class="content-grid source-grid"
    [class.file-column-collapsed]="isFileColumnCollapsed"
    [class.layout-ready]="isColumnLayoutReady"
    [class.column-resize-enabled]="isAnyColumnResizeEnabled()"
    [class.column-resize-dragging]="isColumnResizeDragging"
    [ngStyle]="getContentGridStyles()">
    <section class="column files-column" [class.collapsed]="isFileColumnCollapsed">
      @if (isFileColumnCollapsed && selectedSourceFile) {
        <div class="collapsed-file-indicator" (click)="toggleFileColumn()" [title]="selectedSourceFile.fileName">
          <button class="btn-expand-files" title="Expand file list" aria-label="Expand file list">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>
          <div class="selected-file-name-vertical">
            <span>{{ selectedSourceFile.fileName }}</span>
          </div>
        </div>
      }

      <div class="card files-card" [class.hidden]="isFileColumnCollapsed">
        <div class="files-header-inline">
          <h2 class="card-title">Documents</h2>
          <select class="file-filter-select" [(ngModel)]="fileFilterKind" aria-label="File filter">
            <option value="all">All</option>
            <option value="misc">Misc</option>
          </select>
        </div>

        <div class="file-search-container">
          <div class="search-input-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              [(ngModel)]="fileSearchTerm"
              placeholder="Search"
              class="file-search-input"
              autocomplete="off" />
            @if (fileSearchTerm) {
              <button class="clear-search-btn" (click)="fileSearchTerm = ''" title="Clear search" aria-label="Clear search">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            }
          </div>
        </div>

        <div class="file-tree">
        @if (isSourceDataLoading) {
          <div class="files-loading-state" aria-live="polite">
            <div class="docsila-loader">
              <div class="beat-loader" aria-hidden="true">
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
              </div>
              <span class="loading-text">Loading files...</span>
            </div>
          </div>
        } @else if (filteredSourceFiles.length > 0) {
        @for (file of filteredSourceFiles; track file.id) {
          <div class="tree-item file-item" [class.selected]="selectedFileId === file.id" [class.miscellaneous]="isMiscellaneousFile(file)" (click)="selectFile(file.id)">
            <div class="tree-row">
              <div class="tree-label-group">
                <div class="tree-main-row">
                  <span class="file-icon file-index" aria-hidden="true">{{ getFileNumber(file) }}</span>
                  <span class="tree-label" [title]="file.fileName">{{ file.fileName }}</span>
                  @if (isFileEdited(file)) {
                    <span class="file-edited-dot" aria-label="Document name changed" title="Document name changed"></span>
                  }
                </div>
                <div class="tree-sub-row" [title]="file.subFileName">
                  <span class="tree-sub-label" [title]="file.subFileName">{{ file.subFileName }}</span>
                </div>
                @if (isFileEdited(file)) {
                  @for (entry of getEditedNameEntriesForFile(file); track entry.page) {
                    <div class="tree-edited-name-row" [title]="'P' + entry.page + ' ' + entry.name">
                      <span class="tree-edited-name-page">P{{ entry.page }}</span>
                      <span class="tree-edited-name-label">{{ entry.name }}</span>
                    </div>
                  }
                }
                <div class="tree-meta-row">
                  @if (!isMiscellaneousFile(file)) {
                    <span
                      class="match-type-badge"
                      [ngClass]="file.matchTypeBadgeClass"
                      [title]="file.matchTypeHowDetermined">
                      {{ file.matchTypeLabel }}
                    </span>
                  }
                  @if (file.matchTypeCode === 'TPL' && file.templateId) {
                    <span class="file-meta-chip" [title]="'ID: ' + file.templateId">ID: {{ file.templateId }}</span>
                  }
                  <span class="file-meta-pages" [title]="file.pageRangeSummary">{{ file.pageRangeSummary }}</span>
                </div>
              </div>
              @if (file.startPageNumber !== null && file.endPageNumber !== null) {
                <button class="btn-download-split"
                        (click)="downloadSplitDocument(file, $event)"
                        [disabled]="downloadingFileIds.has(file.id)"
                        [title]="'Download ' + file.fileName">
                  @if (downloadingFileIds.has(file.id)) {
                    <div class="btn-spinner-tiny"></div>
                  } @else {
                    <span class="material-icons">download</span>
                  }
                </button>
              }
            </div>
          </div>
        }
        } @else {
          <div class="source-empty-state-small">
            <p>{{ getSourceFilesEmptyMessage() }}</p>
          </div>
        }
        </div>
      </div>
    </section>

    @if (canResizeSplitter('files-viewer')) {
      <button
        type="button"
        class="column-resizer column-resizer-left"
        [class.is-active]="activeColumnSplitter === 'files-viewer'"
        title="Resize files and preview panel"
        aria-label="Resize files and preview panel"
        (pointerdown)="startColumnResize($event, 'files-viewer')">
        <span class="column-resizer-grip" aria-hidden="true"></span>
      </button>
    }

    <section class="column viewer-column">
      <div class="card viewer-card">
        <div class="viewer-header-inline">
          <h2 class="card-title">Preview</h2>
          <div class="viewer-controls-inline">
            <div class="page-controls">
            <button class="control-btn" (click)="previousPage()" [disabled]="currentPage <= 1" title="Previous Page" aria-label="Previous Page">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <input
              type="text"
              class="page-input"
              [(ngModel)]="pageInput"
              (blur)="goToPage()"
              (keydown)="onPageInputKeydown($event)"
              title="Go to page"
              aria-label="Go to page">
            <span class="page-separator">/</span>
            <span class="page-total">{{ totalPages || 0 }}</span>
            <button class="control-btn" (click)="nextPage()" [disabled]="currentPage >= totalPages" title="Next Page" aria-label="Next Page">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
            </div>

            <div class="zoom-controls">
            <button class="control-btn" (click)="zoomOut()" [disabled]="!sourcePdfDocReady || zoom <= minZoom" title="Zoom Out" aria-label="Zoom Out">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="8" y1="11" x2="14" y2="11"></line>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>
            <input
              type="text"
              class="zoom-input"
              [(ngModel)]="zoomPercentage"
              (blur)="setZoomByPercentage()"
              (keydown)="onZoomInputKeydown($event)"
              title="Enter zoom percentage (50-300)"
              aria-label="Enter zoom percentage (50-300)">
            <span class="zoom-percent-sign">%</span>
            <button class="control-btn" (click)="zoomIn()" [disabled]="!sourcePdfDocReady || zoom >= maxZoom" title="Zoom In" aria-label="Zoom In">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="11" y1="8" x2="11" y2="14"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>
            </div>

            <div class="rotate-controls">
              <button class="control-btn rotate-btn" (click)="rotatePdf()" [disabled]="!sourcePdfDocReady" title="Rotate 90° clockwise" aria-label="Rotate 90 degrees clockwise">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"></path>
                  <path d="M21 3v5h-5"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Warm-cache progress line loader; hidden until download starts and after it hits 100 -->
        <div class="pdf-progress"
             [style.display]="pdfLoadProgress > 0 && pdfLoadProgress < 100 ? 'flex' : 'none'">
          <span class="pdf-progress-label">Loading document {{ pdfLoadProgress }}%</span>
          <span class="pdf-progress-track">
            <span class="pdf-progress-fill" [style.width.%]="pdfLoadProgress"></span>
          </span>
        </div>

        <div class="pdf-preview-host">
        @if (!selectedFileId && !sourcePdfDocReady) {
          <div class="source-preview-empty pdf-preview-state">
            <div class="source-preview-empty-content">
              <h3>Select a file to preview</h3>
              <p>Choose a file from the Documents panel to load preview pages.</p>
            </div>
          </div>
        } @else if (isPreviewPdfLoading && !sourcePdfDocReady) {
          <div class="files-loading-state pdf-preview-state">
            <div class="docsila-loader" role="status" aria-live="polite" aria-label="Loading preview">
              <div class="beat-loader" aria-hidden="true">
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
              </div>
              <p class="loading-text">Loading preview...</p>
            </div>
          </div>
        } @else if (previewPdfLoadError) {
          <div class="source-preview-empty pdf-preview-state">
            <h3>Preview unavailable</h3>
            <p>{{ previewPdfLoadError }}</p>
          </div>
        }
        <!-- Lazy-loading PDF viewer (CDK virtual scroll + per-page canvases),
             extracted into app-pdf-lazy-viewer. The parent keeps all layout /
             zoom / bounding-box logic and reaches the viewport through the
             component's exposed handles. -->
        <app-pdf-lazy-viewer
            [pdfDoc]="sourcePdfDoc"
            [pageNumbers]="pageNumbers"
            [pageWidthsPx]="pageWidthsPx"
            [pageHeightsPx]="pageHeightsPx"
            [pageScales]="pageScales"
            [pageRotations]="pageRotations"
            [pageGapPx]="pageGapPx"
            [pxPerRem]="pxPerRem"
            (scrolledIndexChange)="onVirtualScrolledIndex($event)"
            (pageRendered)="onPageRendered($event)" />
        </div>
      </div>
    </section>

    @if (canResizeSplitter('viewer-tuning')) {
      <button
        type="button"
        class="column-resizer column-resizer-right"
        [class.is-active]="activeColumnSplitter === 'viewer-tuning'"
        title="Resize preview and attributes panel"
        aria-label="Resize preview and attributes panel"
        (pointerdown)="startColumnResize($event, 'viewer-tuning')">
        <span class="column-resizer-grip" aria-hidden="true"></span>
      </button>
    }

    <section class="column tuning-column">
      <div class="card tuning-card">
        <div class="tuning-header">
          <div class="tuning-tabs" role="tablist" aria-label="Source side tabs">
            <button
              type="button"
              class="tuning-tab"
              [class.active]="activeRightTab === 'annotation'"
              [attr.aria-selected]="activeRightTab === 'annotation'"
              role="tab"
              (click)="switchRightTab('annotation')">
              Annotations
            </button>
            <button
              type="button"
              class="tuning-tab"
              [class.active]="activeRightTab === 'reclassification'"
              [attr.aria-selected]="activeRightTab === 'reclassification'"
              role="tab"
              (click)="switchRightTab('reclassification')">
              Attributes
              @if (showAttributesSavedDot) {
                <span class="tuning-tab-indicator-dot" aria-hidden="true"></span>
              }
            </button>
          </div>
        </div>

        <div class="panel-body side-body tuning-content">
        @if (activeRightTab === 'annotation') {
          @if (!selectedFileId) {
            <div class="source-side-empty-state">
              <p>Select a file to view annotations</p>
            </div>
          } @else {
          <div class="annotation-list">
            @for (page of annotationPages; track page) {
              <div class="annotation-item">
                <div
                  class="annotation-row-inline"
                  [class.active]="isAnnotationPageCurrent(page)"
                  [class.is-edited]="isPageChangedUnsaved(page)"
                  (click)="goToAnnotationPage(page)"
                  role="button"
                  tabindex="0"
                  (keydown.enter)="goToAnnotationPage(page)"
                  (keydown.space)="goToAnnotationPage(page)">
                  <span class="annotation-row-label" [class.is-apply-target]="isPageAppliedTarget(page)">
                    P{{ toAbsolutePreviewPage(page) }}
                    <span
                      class="annotation-page-edited-dot"
                      [class.is-visible]="isPageEdited(page)"
                      [attr.aria-hidden]="!isPageEdited(page) ? 'true' : null"
                      title="Document name changed"
                      aria-label="Document name changed"></span>
                  </span>

                  <div class="annotation-doc-inline" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                    <div class="annotation-document-type-select-wrap">
                      <!-- Plain-text trigger: no border / chevron (see .annotation-doc-inline
                           overrides in SCSS). Still the single click + keyboard target that
                           opens the dropdown, which is anchored to this input by id. -->
                      <input
                        type="text"
                        class="annotation-panel-input annotation-document-type-trigger-input annotation-doc-input-compact"
                        [id]="'doc-name-' + page"
                        [value]="getAnnotationPanelState(page).documentName"
                        (mousedown)="$event.stopPropagation()"
                        (click)="toggleAnnotationDocumentTypeDropdown(page, $event)"
                        (keydown.enter)="toggleAnnotationDocumentTypeDropdown(page, $event)"
                        (keydown.space)="$event.preventDefault(); toggleAnnotationDocumentTypeDropdown(page, $event)"
                        aria-haspopup="listbox"
                        [attr.aria-expanded]="isAnnotationDocumentTypeDropdownOpen(page)"
                        [title]="getAnnotationPanelState(page).documentName || 'Select document'"
                        placeholder="Select document"
                        readonly />

                      @if (isAnnotationDocumentTypeDropdownOpen(page)) {
                        <div class="annotation-document-type-dropdown" [ngStyle]="annotationDocumentTypeDropdownStyle || {}" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                          <div class="dropdown-search-container">
                            <input
                              type="text"
                              class="dropdown-search-input"
                              [value]="annotationDocumentTypeSearchByPage[page] ?? ''"
                              (mousedown)="$event.stopPropagation()"
                              (input)="onAnnotationDocumentTypeSearchInput(page, $event)"
                              placeholder="Search Document Name"
                              autocomplete="off" />
                            @if (annotationDocumentTypeSearchByPage[page]?.trim()) {
                              <button
                                type="button"
                                class="clear-search-btn"
                                title="Clear search"
                                (mousedown)="$event.stopPropagation()"
                                (click)="clearAnnotationDocumentTypeSearch(page, $event)">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                  <line x1="18" y1="6" x2="6" y2="18"></line>
                                  <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                              </button>
                            }
                          </div>
                          <div class="annotation-document-type-dropdown-list">
                            @for (documentType of getFilteredAnnotationDocumentTypeOptions(page); track documentType) {
                              <button
                                type="button"
                                class="annotation-document-type-option option-item"
                                [class.is-selected]="documentType === getAnnotationPanelState(page).documentName"
                                [title]="documentType"
                                (mousedown)="$event.stopPropagation()"
                                (click)="selectAnnotationDocumentType(page, documentType, $event)">
                                <span class="annotation-document-type-option-text">{{ documentType }}</span>
                              </button>
                            }

                            @if (getFilteredAnnotationDocumentTypeOptions(page).length === 0) {
                              <div class="annotation-document-type-empty no-options">No matching document names</div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>

                  <div
                    class="annotation-apply-menu-wrap"
                    (mousedown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()">
                    <button
                      type="button"
                      class="annotation-apply-menu-toggle-btn"
                      [class.is-active]="!!getSelectedApplyDirection(page)"
                      [attr.aria-haspopup]="'menu'"
                      [attr.aria-expanded]="isAnnotationApplyMenuOpen(page)"
                      (click)="toggleAnnotationApplyMenu(page, $event)"
                      title="More actions"
                      aria-label="More actions">
                      <span class="material-icons annotation-apply-menu-dots" aria-hidden="true">more_vert</span>
                    </button>

                    @if (isAnnotationApplyMenuOpen(page)) {
                      <div
                        class="annotation-apply-menu"
                        role="menu"
                        (mousedown)="$event.stopPropagation()"
                        (click)="$event.stopPropagation()">
                        <button
                          type="button"
                          class="annotation-apply-menu-item"
                          role="menuitem"
                          [class.is-active]="getSelectedApplyDirection(page) === 'all'"
                          [disabled]="!hasDocNameChangeForPage(page)"
                          (click)="selectAnnotationApplyDirection(page, 'all', $event)">
                          <span class="material-icons">select_all</span>
                          <span>Apply to entire document</span>
                        </button>
                        <button
                          type="button"
                          class="annotation-apply-menu-item"
                          role="menuitem"
                          [class.is-active]="getSelectedApplyDirection(page) === 'up'"
                          [disabled]="!hasDocNameChangeForPage(page) || !canApplyAnnotationUp(page)"
                          (click)="selectAnnotationApplyDirection(page, 'up', $event)">
                          <span class="material-icons">arrow_upward</span>
                          <span>Apply up</span>
                        </button>
                        <button
                          type="button"
                          class="annotation-apply-menu-item"
                          role="menuitem"
                          [class.is-active]="getSelectedApplyDirection(page) === 'down'"
                          [disabled]="!hasDocNameChangeForPage(page) || !canApplyAnnotationDown(page)"
                          (click)="selectAnnotationApplyDirection(page, 'down', $event)">
                          <span class="material-icons">arrow_downward</span>
                          <span>Apply down</span>
                        </button>
                        <button
                          type="button"
                          class="annotation-apply-menu-item annotation-apply-menu-item--comment"
                          role="menuitem"
                          [class.has-comment]="hasCommentForPage(page)"
                          (click)="onSelectAddComment(page, $event)">
                          <span class="material-icons">{{ hasCommentForPage(page) ? 'chat_bubble' : 'chat_bubble_outline' }}</span>
                          <span>Add comment</span>
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
          }
        } @else {
          @if (!selectedFileId) {
            <div class="source-side-empty-state">
              <p>Select a file to view attributes</p>
            </div>
          } @else {
          <div class="source-attributes-column">
            @if (hasSourceAttributes()) {
            <div class="source-attribute-search-container">
              <div class="source-search-input-wrapper">
                <svg class="source-search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0z"></path>
                  <path d="M21 21l-4.35-4.35"></path>
                </svg>
                <input
                  type="text"
                  [(ngModel)]="attributeSearchTerm"
                  placeholder="Search attributes..."
                  class="source-attribute-search-input" />
                @if (attributeSearchTerm) {
                  <button class="source-clear-search-btn" (click)="attributeSearchTerm = ''" title="Clear search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                }
              </div>
            </div>
            }

            <div class="source-truth-values-feed">
              @if (filteredSourceAttributes.length > 0) {
                @for (attribute of filteredSourceAttributes; track attribute.id) {
                  <div
                    class="source-attribute-value-pair"
                    [class.source-na-active]="isSourceNotApplicable(attribute.id)"
                    [class.source-highlighted]="isSourceAttributeHighlighted(attribute.id)"
                    (click)="onSourceAttributeFieldClick(attribute.id, $event)">
                    <div class="source-attribute-header">
                      <div class="source-attribute-info">
                        <span
                          class="source-attribute-indicator"
                          [class.valid]="getSourceValueIndicatorState(attribute.id) === 'valid'"
                          [class.invalid]="getSourceValueIndicatorState(attribute.id) === 'invalid'"
                          [class.na]="getSourceValueIndicatorState(attribute.id) === 'na'">
                          {{ getSourceValueIndicator(attribute.id) }}
                        </span>
                        <div class="source-attribute-name">
                          <div class="source-attribute-label">
                            <span class="source-label-text" [title]="attribute.attributeLabel">{{ attribute.attributeLabel }}</span>
                          </div>
                        </div>
                        @if (attribute.isArray) {
                          <button
                            class="source-btn-add-truth-value"
                            (click)="addSourceNewValueBox(attribute.id); $event.stopPropagation()"
                            [disabled]="isSourceValueReadOnly || isSourceNotApplicable(attribute.id)"
                            [title]="isSourceValueReadOnly ? 'Value editing is disabled' : (isSourceNotApplicable(attribute.id) ? 'Enable field to add values' : 'Add New Value')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                          </button>
                        }
                      </div>
                    </div>

                    <div class="source-truth-value-container" [class.source-values-readonly]="isSourceValueReadOnly">
                      @if (attribute.isArray) {
                        <div class="source-value-boxes">
                          @for (valuePart of getSourceDisplayValueAsArray(attribute.id); track $index; let valueIndex = $index) {
                            @if (!isSourceValueReadOnly && editingAttributeId === attribute.id && editingArrayIndex === valueIndex) {
                              <div class="source-truth-value-wrapper">
                                <div class="source-value-box-edit">
                                  @if (getSourceFieldType(attribute.id) === 'date') {
                                    <div class="source-date-input-wrapper">
                                      <input
                                        type="text"
                                        class="source-truth-value-edit-input source-date-input"
                                        [value]="editingTruthValueText"
                                        (input)="formatSourceDateForInput($event, attribute.id)"
                                        (keydown)="onSourceDateKeydown($event)"
                                        (blur)="onSourceDateInputBlur(attribute.id)"
                                        placeholder="MM/DD/YYYY"
                                        maxlength="10" />
                                      <input
                                        type="date"
                                        class="source-date-picker-hidden"
                                        [value]="getSourceDatePickerValue()"
                                        (change)="onSourceDatePickerChange($event, attribute.id)" />
                                      <span class="material-icons source-date-picker-icon" (mousedown)="onSourceDatePickerIconMousedown($event)" (click)="openSourceDatePicker($event)">calendar_today</span>
                                    </div>
                                  } @else if (getSourceFieldType(attribute.id) === 'select') {
                                    <select
                                      class="source-truth-value-edit-input source-select-input"
                                      [(ngModel)]="editingTruthValueText"
                                      (change)="onSourceSelectFieldChange($event, attribute.id)"
                                      (blur)="onSourceSelectBlur($event, attribute.id)">
                                      <option value="">-- Select --</option>
                                      @for (option of getSourceFieldAllowedValuesWithDescriptions(attribute.id); track option.value) {
                                        <option [value]="option.value" [title]="option.fullDescription">{{ option.displayText }}</option>
                                      }
                                    </select>
                                  } @else {
                                    <textarea
                                      class="source-truth-value-edit-input"
                                      [value]="editingTruthValueText"
                                      (input)="onSourceTextFieldInput($event, attribute.id)"
                                      (blur)="onSourceTruthValueBlur(attribute.id)"
                                      [placeholder]="getSourcePlaceholderText(attribute.id)"
                                      rows="3"></textarea>
                                  }
                                </div>
                                @if (isSourceModified(attribute.id)) {
                                  <button
                                    class="source-btn-undo"
                                    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                    (click)="undoSourceChange(attribute.id, $event)"
                                    title="Undo changes">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <path d="M3 7v6h6"></path>
                                      <path d="M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13"></path>
                                    </svg>
                                  </button>
                                }
                              </div>
                            } @else {
                              @if (getSourceFieldType(attribute.id) === 'date') {
                                <div class="source-value-box source-value-box-date"
                                  [class.source-empty-value-box]="!valuePart.trim()"
                                  [class.source-modified]="isSourceModified(attribute.id)"
                                  [class.source-disabled]="isSourceNotApplicable(attribute.id)"
                                  (click)="!isSourceNotApplicable(attribute.id) && startEditingSourceAttribute(attribute.id, valueIndex)">
                                  <span class="source-value-text" [class.source-placeholder-text]="!valuePart.trim()">{{ valuePart || 'MM/DD/YYYY' }}</span>
                                  <span class="material-icons source-value-icon source-date-icon">calendar_today</span>
                                </div>
                              } @else if (getSourceFieldType(attribute.id) === 'select') {
                                <div class="source-value-box source-value-box-select"
                                  [class.source-empty-value-box]="!valuePart.trim()"
                                  [class.source-modified]="isSourceModified(attribute.id)"
                                  [class.source-disabled]="isSourceNotApplicable(attribute.id)"
                                  (click)="!isSourceNotApplicable(attribute.id) && startEditingSourceAttribute(attribute.id, valueIndex)">
                                  <span class="source-value-text" [class.source-placeholder-text]="!valuePart.trim()">{{ valuePart ? getSourceSelectDisplayLabel(attribute.id, valuePart) : '-- Select --' }}</span>
                                  <span class="material-icons source-value-icon source-dropdown-icon">arrow_drop_down</span>
                                </div>
                              } @else {
                                <div class="source-value-box"
                                  [class.source-empty-value-box]="!valuePart.trim()"
                                  [class.source-modified]="isSourceModified(attribute.id)"
                                  [class.source-disabled]="isSourceNotApplicable(attribute.id)"
                                  (click)="!isSourceNotApplicable(attribute.id) && startEditingSourceAttribute(attribute.id, valueIndex)">
                                  @if (valuePart.trim()) {
                                    {{ valuePart }}
                                  } @else {
                                    <span class="source-no-value-text">Enter the value, click + to add</span>
                                  }
                                </div>
                              }
                            }
                          }
                        </div>
                      } @else {
                        @if (!isSourceValueReadOnly && editingAttributeId === attribute.id && editingArrayIndex === null) {
                          <div class="source-truth-value-wrapper">
                            <div class="source-value-box-edit">
                              @if (getSourceFieldType(attribute.id) === 'date') {
                                <div class="source-date-input-wrapper">
                                  <input
                                    type="text"
                                    class="source-truth-value-edit-input source-date-input"
                                    [value]="editingTruthValueText"
                                    (input)="formatSourceDateForInput($event, attribute.id)"
                                    (keydown)="onSourceDateKeydown($event)"
                                    (blur)="onSourceDateInputBlur(attribute.id)"
                                    placeholder="MM/DD/YYYY"
                                    maxlength="10" />
                                  <input
                                    type="date"
                                    class="source-date-picker-hidden"
                                    [value]="getSourceDatePickerValue()"
                                    (change)="onSourceDatePickerChange($event, attribute.id)" />
                                  <span class="material-icons source-date-picker-icon" (mousedown)="onSourceDatePickerIconMousedown($event)" (click)="openSourceDatePicker($event)">calendar_today</span>
                                </div>
                              } @else if (getSourceFieldType(attribute.id) === 'select') {
                                <select
                                  class="source-truth-value-edit-input source-select-input"
                                  [(ngModel)]="editingTruthValueText"
                                  (change)="onSourceSelectFieldChange($event, attribute.id)"
                                  (blur)="onSourceSelectBlur($event, attribute.id)">
                                  <option value="">-- Select --</option>
                                  @for (option of getSourceFieldAllowedValuesWithDescriptions(attribute.id); track option.value) {
                                    <option [value]="option.value" [title]="option.fullDescription">{{ option.displayText }}</option>
                                  }
                                </select>
                              } @else {
                                <textarea
                                  class="source-truth-value-edit-input"
                                  [value]="editingTruthValueText"
                                  (input)="onSourceTextFieldInput($event, attribute.id)"
                                  (blur)="onSourceTruthValueBlur(attribute.id)"
                                  [placeholder]="getSourcePlaceholderText(attribute.id)"
                                  rows="3"></textarea>
                              }
                            </div>
                            @if (isSourceModified(attribute.id)) {
                              <button
                                class="source-btn-undo"
                                (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                (click)="undoSourceChange(attribute.id, $event)"
                                title="Undo changes">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                  <path d="M3 7v6h6"></path>
                                  <path d="M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13"></path>
                                </svg>
                              </button>
                            }
                          </div>
                        } @else {
                          @if (getSourceFieldType(attribute.id) === 'date') {
                            <div class="source-value-box source-value-box-date"
                              [class.source-empty-value-box]="!getSourceDisplayValue(attribute.id).trim()"
                              [class.source-modified]="isSourceModified(attribute.id)"
                              [class.source-disabled]="isSourceNotApplicable(attribute.id)"
                              (click)="!isSourceNotApplicable(attribute.id) && startEditingSourceAttribute(attribute.id, null)">
                              <span class="source-value-text" [class.source-placeholder-text]="!getSourceDisplayValue(attribute.id).trim()">{{ getSourceDisplayValue(attribute.id) || 'MM/DD/YYYY' }}</span>
                              <span class="material-icons source-value-icon source-date-icon">calendar_today</span>
                            </div>
                          } @else if (getSourceFieldType(attribute.id) === 'select') {
                            <div class="source-value-box source-value-box-select"
                              [class.source-empty-value-box]="!getSourceDisplayValue(attribute.id).trim()"
                              [class.source-modified]="isSourceModified(attribute.id)"
                              [class.source-disabled]="isSourceNotApplicable(attribute.id)"
                              (click)="!isSourceNotApplicable(attribute.id) && startEditingSourceAttribute(attribute.id, null)">
                              <span class="source-value-text" [class.source-placeholder-text]="!getSourceDisplayValue(attribute.id).trim()">{{ getSourceDisplayValue(attribute.id) ? getSourceSelectDisplayLabel(attribute.id, getSourceDisplayValue(attribute.id)) : '-- Select --' }}</span>
                              <span class="material-icons source-value-icon source-dropdown-icon">arrow_drop_down</span>
                            </div>
                          } @else {
                            <div class="source-value-box"
                              [class.source-empty-value-box]="!getSourceDisplayValue(attribute.id).trim()"
                              [class.source-modified]="isSourceModified(attribute.id)"
                              [class.source-disabled]="isSourceNotApplicable(attribute.id)"
                              (click)="!isSourceNotApplicable(attribute.id) && startEditingSourceAttribute(attribute.id, null)">
                              @if (getSourceDisplayValue(attribute.id).trim()) {
                                {{ getSourceDisplayValue(attribute.id) }}
                              } @else {
                                <span class="source-no-value-text">Enter the value, click + to add</span>
                              }
                            </div>
                          }
                        }
                      }
                    </div>
                  </div>
                }
              } @else {
                <div class="source-empty-state-small">
                  <p>{{ getSourceAttributesEmptyMessage() }}</p>
                  @if (getSourceAttributesEmptySubtitle()) {
                    <p class="source-empty-subtitle">{{ getSourceAttributesEmptySubtitle() }}</p>
                  }
                </div>
              }
            </div>
          </div>
          }
        }
      </div>
      </div>
    </section>
  </div>
</div>
